import { render, staticRenderFns } from "./actionplan-standard.vue?vue&type=template&id=1b5cc43c&scoped=true"
import script from "./actionplan-standard.vue?vue&type=script&lang=js"
export * from "./actionplan-standard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5cc43c",
  null
  
)

export default component.exports